<template>
  <div class="header_wrapper">
    <header>
      <nav class="header-primary">
        <div class="cta-menu-opener">
          <button
            :class="{ 'is-active': isBurgerActive }"
            @click.prevent="toggleMainMenu"
            class="hamburger hamburger--spin"
            type="button"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
        <div class="brand-nav col-3 text-center">
          <router-link to="/">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277.5 125.4">
              <path
                d="M93.4 60h11c5.2 0 8-2.3 8-6.6v-2.7c0-2.4-1.7-4.5-4.1-5.1 2.1-.9 3.1-2.3 3.1-4.4v-2.8c0-2.6-.8-6.1-7.9-6.1H93.4c-.4 0-.8.3-.8.8v26.1c0 .5.4.8.8.8zm5.5-22.6h3.9c1.7 0 2.5.7 2.5 2v2.4c0 .5-.2 2-2.5 2h-3.9v-6.4zm0 11.2h4.7c1 0 2.6.3 2.6 2.3v1.7c0 1.7-1 2.4-3.5 2.4h-3.9v-6.4zm3.2 27h-3.5v-4.1c0-.4-.3-.8-.8-.8h-4.4c-.4 0-.8.3-.8.8v4.1h-2c-.4 0-.8.3-.8.8v3.3c0 .4.3.8.8.8h2v10.6c0 3.5 2 5.2 6.1 5.2.9 0 2.1-.2 3.3-.5.3-.1.6-.4.6-.7V92c0-.2-.1-.5-.3-.6-.1-.1-.3-.2-.5-.2h-.2c-.6.1-1.3.2-1.8.2-1.2 0-1.2-.8-1.2-1.1v-9.8h3.5c.4 0 .8-.3.8-.8v-3.3c-.1-.4-.4-.8-.8-.8zM32.9 8.9H15.5c-4.8 0-8.7 3.9-8.7 8.7v92.5c0 4.8 3.9 8.7 8.7 8.7h17.4c.7 0 1.3-.6 1.3-1.3v-11c0-.7-.6-1.3-1.3-1.3h-6.5c-3.2 0-5.8-2.6-5.8-5.8v-71c0-3.2 2.6-5.8 5.8-5.8h6.5c.7 0 1.3-.6 1.3-1.3v-11c0-.8-.6-1.4-1.3-1.4zm184 66.3c-2.1 0-4.7 1.1-6.2 2l-.4-1.1c-.1-.3-.4-.5-.7-.5h-3.4c-.4 0-.8.3-.8.8V102c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8v-6.3c1.4.3 3.5.6 5.2.6 4.6 0 6.8-2.4 6.8-7.5v-6.1c-.1-6.2-3.6-7.5-6.5-7.5zm.4 13.6c0 1.5-.7 2.3-2.2 2.3-1.3 0-2.8-.3-3.8-.5V82c.9-.8 2.5-1.6 3.8-1.6 1.5 0 2.2.7 2.2 2.3v6.1zM169.1 67h4.4c.4 0 .8-.3.8-.8v-6.3c1.4.3 3.5.6 5.1.6 4.6 0 6.8-2.4 6.8-7.5v-6.1c0-6.2-3.5-7.5-6.4-7.5-2.1 0-4.7 1.1-6.2 2l-.4-1.1c-.1-.3-.4-.5-.7-.5h-3.4c-.4 0-.8.3-.8.8v25.6c0 .4.4.8.8.8zm5.2-20.8c.9-.8 2.5-1.6 3.8-1.6 1.5 0 2.2.7 2.2 2.3V53c0 1.5-.7 2.3-2.2 2.3-1.3 0-2.8-.3-3.8-.5v-8.6zm89.4 22c-2.6 0-4.7 2-4.7 4.8s2.1 4.8 4.7 4.8 4.7-2 4.7-4.8-2.1-4.8-4.7-4.8zm0 8.8c-2.2 0-4-1.7-4-4 0-2.4 1.8-4 4-4s3.9 1.7 3.9 4c0 2.4-1.7 4-3.9 4zm-55.3-17h4.4c.4 0 .8-.3.8-.8V47.7c1.2-1 2.8-1.8 4.8-2.5.3-.1.5-.4.5-.7v-4.1c0-.2-.1-.5-.3-.6-.1-.1-.3-.2-.5-.2h-.2c-1.8.5-3.9 1.4-5 2.2l-.3-1.3c-.1-.4-.4-.6-.8-.6h-3.6c-.4 0-.8.3-.8.8v18.7c.3.3.6.6 1 .6zm-71.7 0h4.4c.4 0 .8-.3.8-.8V46.7c1.3-.7 3.3-1.5 4.4-1.5 1 0 1.5.5 1.5 1.5v12.6c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V46.7c1.3-.7 3.3-1.5 4.4-1.5 1 0 1.5.5 1.5 1.5v12.6c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V45.9c0-4.4-1.5-6.5-4.7-6.5-2.6 0-5.6.7-8.1 2-.7-1.3-2-2-3.7-2-2.4 0-5.6.8-8.1 2l-.4-1.1c-.1-.3-.4-.5-.7-.5h-3.2c-.4 0-.8.3-.8.8v18.7c-.1.4.2.7.7.7zM59.8 8.9H42.4c-.7 0-1.3.6-1.3 1.3v11c0 .7.6 1.3 1.3 1.3h6.5c3.2 0 5.8 2.6 5.8 5.8v14.5c0 .9-.2 1.8-.6 2.6l-7.8 15.7c-.4.8-.7 1.7-.7 2.7 0 1 .2 1.9.7 2.7l7.8 15.7c.4.8.6 1.7.6 2.6v14.5c0 3.2-2.6 5.8-5.8 5.8h-6.5c-.7 0-1.3.6-1.3 1.3v11c0 .7.6 1.3 1.3 1.3h17.4c4.8 0 8.7-3.9 8.7-8.7V83.7c0-1.5-.4-2.8-1-4.1l-6-12.1c-.5-1.1-.8-2.4-.8-3.7 0-1.3.3-2.5.8-3.7l6-12.1c.6-1.2 1-2.6 1-4.1V17.6c.1-4.8-3.9-8.7-8.7-8.7zm206 63.2c0-1-.7-1.6-1.8-1.6h-2.2v5h1.1v-1.8h.7l1.2 1.8h1.2l-1.3-1.9c.7-.2 1.1-.7 1.1-1.5zm-1.8.7h-1v-1.4h1c.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm-29.8 2.4c-5.8 0-8.7 2.7-8.7 8.1V88c0 5.5 3 8.2 9.1 8.2 2.3 0 5-.5 6.7-1 .3-.1.6-.4.6-.7v-3.2c0-.2-.1-.5-.3-.6-.1-.1-.3-.2-.5-.2h-.2c-1.9.4-4.2.7-5.7.7-2.8 0-3.7-.7-3.7-2.9v-.6h10.1c.4 0 .8-.3.8-.8v-3.5c0-5.5-2.6-8.2-8.2-8.2zm2.5 8.1h-5.2v-.9c0-1.7.9-2.6 2.7-2.6 1.7 0 2.5.8 2.5 2.6v.9zM204.6 52c.4 0 .8-.3.8-.8v-3.5c0-5.7-2.6-8.4-8.2-8.4-5.8 0-8.7 2.7-8.7 8.1v4.7c0 5.5 3 8.2 9.1 8.2 2.3 0 5-.5 6.7-1 .3-.1.6-.4.6-.7v-3.2c0-.2-.1-.5-.3-.6-.1-.1-.3-.2-.5-.2h-.2c-1.9.4-4.2.7-5.7.7-2.8 0-3.7-.7-3.7-2.9V52h10.1zm-10.1-5.3c0-1.7.9-2.6 2.7-2.6 1.7 0 2.5.8 2.5 2.6v.9h-5.2v-.9zM169 75.6h-4.4c-.4 0-.8.3-.8.8V89c-1.3.7-3.3 1.5-4.4 1.5-1 0-1.5-.5-1.5-1.5V76.4c0-.4-.3-.8-.8-.8h-4.4c-.4 0-.8.3-.8.8v13.4c0 4.4 1.5 6.5 4.7 6.5 2.4 0 5.6-.8 8.1-2l.4 1.1c.1.3.4.5.7.5h3.2c.4 0 .8-.3.8-.8V76.4c0-.4-.4-.8-.8-.8zm28.8-.4c-2.6 0-5.6.7-8.1 2-.7-1.3-2-2-3.7-2-2.4 0-5.6.8-8.1 2l-.4-1.1c-.1-.3-.4-.5-.7-.5h-3.2c-.4 0-.8.3-.8.8v18.7c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V82.5c1.3-.7 3.3-1.5 4.4-1.5 1 0 1.5.5 1.5 1.5v12.6c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V82.5c1.3-.7 3.3-1.5 4.4-1.5 1 0 1.5.5 1.5 1.5v12.6c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V81.7c-.1-4.4-1.7-6.5-4.8-6.5zm-84.6 0c-7.6 0-9.1 4.5-9.1 8.2v4.7c0 3.7 1.6 8.2 9.1 8.2 7.6 0 9.1-4.4 9.1-8.2v-4.7c0-3.7-1.6-8.2-9.1-8.2zm3.1 13.1c0 2.5-1.7 3-3.2 3-1.4 0-3.2-.5-3.2-3v-5c0-2.5 1.7-3 3.2-3 1.4 0 3.2.5 3.2 3v5zm29.1-6.9c2.1-.9 3.1-2.3 3.1-4.4v-2.8c0-2.6-.8-6.1-7.9-6.1h-10.2c-.4 0-.8.3-.8.8V95c0 .4.3.8.8.8h11c5.2 0 8-2.3 8-6.6v-2.7c0-2.4-1.6-4.5-4-5.1zm-9.6-8.2h3.9c1.7 0 2.5.7 2.5 2v2.4c0 .5-.2 2-2.5 2h-3.9v-6.4zm7.4 15.2c0 1.7-1 2.4-3.5 2.4h-3.9v-6.4h4.7c1 0 2.6.3 2.6 2.3v1.7zm-10.4-29.1V40.6c0-.4-.3-.8-.8-.8h-4.4c-.4 0-.8.3-.8.8v12.6c-1.3.7-3.3 1.5-4.4 1.5-1 0-1.5-.5-1.5-1.5V40.6c0-.4-.3-.8-.8-.8h-4.4c-.4 0-.8.3-.8.8V54c0 4.4 1.5 6.5 4.7 6.5 2.4 0 5.6-.8 8.1-2l.4 1.1c.1.3.4.5.7.5h3.2c.5-.1.8-.4.8-.8zm122.4 16.1h-.2c-1.8.5-3.9 1.4-5 2.2l-.3-1.3c-.1-.4-.4-.6-.8-.6h-3.6c-.4 0-.8.3-.8.8v18.7c0 .4.3.8.8.8h4.4c.4 0 .8-.3.8-.8V83.5c1.2-1 2.8-1.8 4.8-2.5.3-.1.5-.4.5-.7v-4.1c0-.2-.1-.5-.3-.6 0-.2-.1-.2-.3-.2z"
              />
            </svg>
          </router-link>
        </div>

        <div class="right-nav">
          <div
            v-if="!searchDisabled"
            class="__cta-search"
            @click="searchOpen = !searchOpen"
          >
            <svg
              key="0"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="icon icon-search"
            >
              <path
                fill="currentColor"
                d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"
                class=""
              ></path>
            </svg>
          </div>
          <b-link href="#" class="lang-switcher" @click="changeLang">
            {{ $t("header.lang") }}
          </b-link>
        </div>
      </nav>

      <nav
        class="nav-mobile-wrapper nav-level-1 nav-fixed-container"
        :class="{ '__is-active': isBurgerActive }"
      >
        <div class="primary-nav">
          <b-link
            v-for="main in mainNavigation"
            v-bind:key="main.entity_id"
            :to="`${getPathUrl()}${main.slug}`"
          >
            {{ main.page_title }}
          </b-link>
          <span v-for="top in topNavigation" v-bind:key="top.entity_id">
            <b-link v-if="!top.pdf" :to="`${getPathUrl()}${top.slug}`">
              {{ top.page_title }}
            </b-link>
            <b-link
              v-else-if="top.pdf && top.pdf.file && top.pdf.file.url"
              :href="top.pdf.file.url"
              target="_blank"
            >
              {{ top.page_title }}
            </b-link>
          </span>
        </div>
        <multi-level-menu :menuItems="getMockMenu" />
      </nav>
    </header>



    <transition name="fade">
      <section v-if="q && searchOpen" class="search-results row no-gutters">
        <div class="coverflow ol col-lg-7 offset-lg-2">
          <div v-if="searchResult.items">
            <h3>
              {{
                $t("generalUi.searchCount", {
                  count: searchResult.queries.request[0].totalResults,
                  query: q
                })
              }}
            </h3>

            <div
              class="search-results__item"
              v-for="(post, i) in searchResult.items"
              v-bind:post="post"
              :key="i"
            >
              <a class="text-dark" :href="post.link">
                <em>{{ post.title }}</em>
              </a>
              <p>{{ post.snippet }}</p>
            </div>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              per-page="10"
              aria-controls="my-table"
              @change="paginationChange"
            ></b-pagination>
          </div>
          <div v-else>
            <h3>{{ $t("generalUi.noResult") }}</h3>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import headerMixing from '../../../mixins/header'
import MultiLevelMenu from '../menu/MultiLevelMenu.vue'
import MockDataMenu from '../../../../public/json/local_site_map_5_en-CA.json'

export default {
  components: { MultiLevelMenu },
  name: 'Header',
  mixins: [headerMixing],
  computed: {
    getMockMenu () {
      return MockDataMenu
    }
  },
  methods: {
    /**
     * Set the burger menu state
     * @returns {Void}
     */
    toggleMainMenu () {
      this.isBurgerActive = !this.isBurgerActive
    },
    /**
     * Add class active on the sub menu
     * @param {Object} el
     * @returns {Void}
     */
    toggleSubMenu (el) {
      el.target.querySelector('.nav-level-2').classList.add('__is-active')
    },
    /**
     * Remove class active
     * @param {Object} el
     * @returns {Void}
     */
    backToMenu (el) {
      // get all elements
      const elems = document.querySelectorAll('.nav-level-2')
      // loop on the elements
      elems.forEach((element) => {
        // remove class
        element.classList.remove('__is-active')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header_wrapper {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  border-bottom: 1px solid $grey-b2b;
  height: 45px;
}
a {
  transition: all 0.3s ease-out;
  text-decoration: none;
}

.nav-fixed-container {
  height: calc(
    100vh - 45px
  ); /* Fallback for browsers that do not support Custom Properties */
  height: calc((var(--vh, 1vh) * 100) - 45px);
  width: 100%;

  position: fixed;
  left: 0;
  top: 45px;
  z-index: 99;

  transform: translateX(100%);

  transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);

  overflow: scroll;

  &.__is-active {
    transform: translateX(0%);
  }
}

.header-primary {
  background-color: $red;
  height: 4.5rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
}

.brand-nav {
  svg {
    fill: $white;
    height: 3rem;
  }
}

.right-nav {
  display: flex;

  .__cta-search {
    width: 30px;
    svg path {
      fill: white;
    }
  }
}
.lang-switcher {
  color: #fff;
}
.nav-mobile-wrapper {
  background-color: $grey-b2b;

  label {
    margin: 0;
  }

  & a {
    height: 7rem;
    display: flex;
    font-weight: 600;

    &.router-link-active {
      background-color: $menu-active;
    }
  }

  .store-nav {
    background-color: $grey-light;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 2rem;
    position: relative;

    label {
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 0;
      text-align: center;
    }

    a {
      display: flex;
      text-decoration: none;
      justify-content: center;
      align-items: center;
      padding: 0 2.5rem;
      background-color: #fff;
      border-bottom: 1px solid $grey-b2b;
      position: relative;
      > * {
        cursor: pointer;
      }
    }
    .cta-my-strore {
      address {
        font-size: 0.9rem;
        margin-bottom: 0;
        line-height: 1.22;
        font-weight: 600;
      }
    }

    .icon-group {
      position: absolute;
      right: 2.5rem;
      top: 50%;
      transform: translateY(-50%);

      svg {
        margin-right: 0.8rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .primary-nav {
    & > a,
    & > span a {
      color: $white;
      background-color: $black;
      font-weight: 600;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid $dark-grey-b2b;

      label {
        pointer-events: none;
      }

      &.router-link-active {
        background-color: $menu-active;
      }
    }
  }

  .nav-level-2 {
    background-color: $white;

    & a:not(.cta-back-to-menu) {
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid $grey-light;

      svg {
        position: absolute;
        right: 1.5rem;
        path {
          fill: $red;
        }
      }
    }
  }
}

.__actif {
  background-color: $red;
  color: white;
}
.cta-back-to-menu {
  background-color: $black;
  color: $white;
  justify-content: center;
  align-items: center;

  label {
    margin: 0 0 0 1.5rem;
  }
}
.cta-all {
  background-color: $red;
  color: white;
  border-bottom: 1px solid $grey-b2b !important;

  svg path {
    fill: currentColor !important;
  }
}

.search-container {
  transform: translateX(100%);
  transition: all 0.3s ease;
  pointer-events: none;
  border-bottom: 1px solid $grey-light;

  input {
    width: 100vw;
    height: 70px;
    padding: 0 3.5rem;
    background-color: $grey-b2b;
    border: none;
    transition: all 0.3s ease;
    border-radius: 0;
  }

  .input-reset {
    position: absolute;
    right: 4.5rem;
    top: calc(50% - 10px);
  }

  &.active {
    pointer-events: auto;
    transform: translateX(0%);
  }
}
.search-results {
  max-height: calc(
    100vh - 100px
  ) !important; /* Fallback for browsers that do not support Custom Properties */
  max-height: calc((var(--vh, 1vh) * 100) - 100px) !important;

  .coverflow {
    padding-bottom: 40px;
    overflow: auto;
  }
}
</style>